// Environment detection utilities - single source of truth for all environment checks

// Returns true for any non-production environment
export const isPreviewOrInternalDomain = () => {
  if (typeof window === 'undefined') return true; // Default to preview mode on server
  const hostname = window.location.hostname;

  // Block Netlify internal/preview domains
  const isNetlifyInternal =
    hostname.includes('netlify.app') ||
    hostname.includes('--singwiththestars.netlify.app') ||
    hostname.match(/^[a-f0-9-]+--.+\.netlify\.app$/); // Build preview URLs

  // Block other development/preview patterns
  const isDevDomain =
    hostname.includes('localhost') ||
    hostname.includes('127.0.0.1') ||
    hostname.includes('ngrok') ||
    hostname.includes('ngrok-free.app') ||
    hostname.includes('tunnel');

  // Block based on environment or hostname patterns
  const isDevMode =
    process.env.NODE_ENV !== 'production' ||
    hostname.match(/\d+\.\d+\.\d+\.\d+/) || // IP addresses
    hostname.includes('dev') ||
    hostname.includes('test') ||
    hostname.includes('staging');

  return isNetlifyInternal || isDevDomain || isDevMode;
};

// Returns true only for localhost development
export const isLocalDevelopment = () => {
  return (
    process.env.NODE_ENV === 'development' &&
    typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1')
  );
};

// Get the correct Netlify function URL based on environment
export const getNetlifyFunctionUrl = functionName => {
  return isLocalDevelopment()
    ? `http://localhost:8888/.netlify/functions/${functionName}`
    : `/.netlify/functions/${functionName}`;
};

// Check if we're in a production environment
export const isProduction = () => {
  return process.env.NODE_ENV === 'production' && !isPreviewOrInternalDomain();
};

// Check if we should show debug output
export const isDebugMode = () => {
  return isPreviewOrInternalDomain();
};

// Check if we should initialize analytics services
export const shouldInitializeAnalytics = () => {
  // Must be production build
  if (process.env.NODE_ENV !== 'production') {
    return false;
  }

  // Must be on main production domain (not preview/deploy)
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    return (
      hostname === 'www.singwiththestars.com' ||
      hostname === 'singwiththestars.com'
    );
  }

  // Server-side: check URL environment variable (Netlify sets this)
  if (process.env.URL) {
    return (
      process.env.URL.includes('singwiththestars.com') &&
      !process.env.URL.includes('deploy-preview') &&
      !process.env.URL.includes('branch-deploy')
    );
  }

  // Fallback: assume production if we can't determine
  return true;
};
